import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-74358d13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  style: {"height":"102vh"},
  class: "p-grid"
}
const _hoisted_3 = { class: "p-col-12 p-md-6 p-p-3 p-d-flex p-flex-column p-ai-center p-jc-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-md-6 p-d-flex image p-ai-center p-jc-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/account.png",
    alt: "LOCAA"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.base = _ctx.getBaseRoute(_ctx.$route.path, _ctx.$route.name)))
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          style: {"position":"absolute","left":"10px","top":"10px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_ctx.base.nextUrl))),
          icon: _ctx.base.icon
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ]),
      _hoisted_4
    ])
  ]))
}